module.exports = __webpack_public_path__ + "static/ab3-c9bffa4302005c61a8dc0d98724795c6.jpg";